(function ($) {
	"use strict";
	$(function () {
		var isButtonClick = false;

		$('.js-newsletter-form').submit(function (e) {
			e.preventDefault();
			var $this = $(this);


			if (isButtonClick) {
				return false;
			}

			isButtonClick = true;

			$.ajax({
				type: "post",
				context: this,
				dataType: "json",
				url: localize.ajaxurl,
				data: {
					action: "sendgrid_subscribe",
					datas: $this.serializeArray(),
					nonce: localize.nonce
				},
				success: function (response) {
					isButtonClick = false;


					var bottom = null;
					var width = 600;

					if (window.innerWidth <= 767) {
						bottom = 0;
					}

					if (!response['fault']) {
						$this.trigger('reset');
						if ($('#succes-modal').length) {
							$('#succes-modal').iziModal('destroy');
						}
						$("#succes-modal").iziModal({
							title: response['msg'],
							headerColor: '#5c18b9',
							width: width,
							timeout: 3000,
							timeoutProgressbar: true,
							transitionIn: 'fadeInUp',
							transitionOut: 'fadeOutDown',
							pauseOnHover: false,
							radius: 0,
							bottom: bottom
						});
						$('#succes-modal').iziModal('open');
					} else {
						if ($('#error-modal').length) {
							$('#error-modal').iziModal('destroy');
						}
						if (response['mailchimp_error']) {
							$("#error-modal").iziModal({
								title: response['msg'],
								headerColor: '#f8485e',
								width: width,
								timeout: 3000,
								timeoutProgressbar: true,
								transitionIn: 'fadeInUp',
								transitionOut: 'fadeOutDown',
								pauseOnHover: false,
								radius: 0,
								bottom: bottom
							});
							$('#error-modal').iziModal('open');

						} else {
							$("#error-modal").iziModal({
								title: response['msg'],
								headerColor: '#f8485e',
								width: width,
								timeout: 3000,
								timeoutProgressbar: true,
								transitionIn: 'fadeInUp',
								transitionOut: 'fadeOutDown',
								pauseOnHover: false,
								radius: 0,
								bottom: bottom
							});
							$('#error-modal').iziModal('open');
						}
					}
				}
			});

			return false;

		});

	});
})(jQuery);
